import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import KeywordsEdit from './KeywordsEdit';
import KeywordsInfo from './KeywordsInfo';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.KeywordSelection.title',
    defaultMessage: 'Are these keywords relevant?',
    description: '[Type: Header][Vis: med] - keyword review title'
  },
  description: {
    id: 'OpenEndedCoding.KeywordSelection.description',
    defaultMessage: 'Review the keywords associated with each theme.',
    description: '[Type: Header][Vis: med] - keyword review description'
  },
  question: {
    id: 'OpenEndedCoding.KeywordSelection.question',
    defaultMessage: 'Question: "{questionText}"',
    description: '[Type: Header][Vis: med] - keyword review description'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      padding: `${theme.spacing[5]}px ${theme.spacing[9]}px`
    }
  };
});
const KeywordSelection = ({
  questionText,
  themes,
  keywords,
  keywordsLoading,
  setKeywords
}) => {
  const classes = useStyles();
  return _jsxs(Box, {
    className: classes.container,
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        children: _jsx(T, {
          desc: COPY.title
        })
      })
    }), _jsx(Box, {
      mb: 1,
      children: _jsx(Typography, {
        component: "div",
        variant: "body",
        children: _jsx(T, {
          desc: COPY.description
        })
      })
    }), questionText && _jsx(Box, {
      mb: 6,
      children: _jsx(Typography, {
        component: "div",
        variant: "body",
        children: _jsx(T, {
          desc: COPY.question,
          values: {
            questionText
          }
        })
      })
    }), _jsxs(Grid, {
      noBleeds: true,
      noGutters: true,
      fluid: true,
      children: [_jsx(Grid.Item, {
        xs: 12,
        sm: 12,
        md: 9,
        children: _jsx(KeywordsEdit, {
          themes: themes,
          keywords: keywords,
          keywordsLoading: keywordsLoading,
          setKeywords: setKeywords
        })
      }), _jsx(Grid.Item, {
        xs: 12,
        sm: 12,
        md: 3,
        children: _jsx(KeywordsInfo, {})
      })]
    })]
  });
};
export default KeywordSelection;